import React, { Component } from 'react'
import AdminRestaurantList from '../restaurants/admin/AdminRestaurantList'
import AdminRestaurantListCreate from '../restaurants/admin/AdminRestaurantListCreate'
import AdminRestaurantListDelete from '../restaurants/admin/AdminRestaurantListDelete'
import AdminPendingReview from '../restaurants/admin/AdminPendingReview'
import AdminIssuesList from '../restaurants/admin/AdminIssuesList'
import AdminReviewList from '../restaurants/admin/AdminReviewList'
import { connect } from 'react-redux'
import { firestoreConnect } from 'react-redux-firebase'
import { compose } from 'redux'
import { Redirect, Link } from 'react-router-dom'
import { addFavorite } from '../../store/actions/restaurantActions'
import { tagFunctions } from '../restaurants/Tags'
import { hoursFunctions } from '../restaurants/Hours'

class AdminDashboard extends Component {


// the firestoreConnect listeners unmount and mount in the wrong order leading to conflicts
// between this dashboard and other dashboards, this corrects that

  componentDidMount(props) {
    if(this.props.auth && this.props.auth.uid){
    this.props.firestore.unsetListener({
      collection: 'users',
      doc: this.props.auth.uid,
      subcollections: [
        { collection: 'adminMessages' }
      ],
      storeAs: 'adminMessages'
    })
    this.props.firestore.unsetListener({
      collection: 'users',
      doc: this.props.auth.uid,
      subcollections: [
        { collection: 'adminReviewMessages' }
      ],
      storeAs: 'adminReviewMessages'
    })
    this.props.firestore.unsetListener({
      collection: 'users',
      doc: this.props.auth.uid,
      subcollections: [
        { collection: 'adminIssueMessages' }
      ],
      storeAs: 'adminIssueMessages'
    })
    this.props.firestore.setListener({
      collection: 'users',
      doc: this.props.auth.uid,
      subcollections: [
        { collection: 'adminMessages' }
      ],
      storeAs: 'adminMessages'
    })
    this.props.firestore.setListener({
      collection: 'users',
      doc: this.props.auth.uid,
      subcollections: [
        { collection: 'adminReviewMessages' }
      ],
      storeAs: 'adminReviewMessages'
    })
    this.props.firestore.setListener({
      collection: 'users',
      doc: this.props.auth.uid,
      subcollections: [
        { collection: 'adminIssueMessages' }
      ],
      storeAs: 'adminIssueMessages'
    })
    }
  }

  componentWillUnmount(props) {
    if(this.props.auth && this.props.auth.uid){
    this.props.firestore.unsetListener({
      collection: 'users',
      doc: this.props.auth.uid,
      subcollections: [
        { collection: 'adminMessages' }
      ],
      storeAs: 'adminMessages'
    })
    this.props.firestore.unsetListener({
      collection: 'users',
      doc: this.props.auth.uid,
      subcollections: [
        { collection: 'adminReviewMessages' }
      ],
      storeAs: 'adminReviewMessages'
    })
    this.props.firestore.unsetListener({
      collection: 'users',
      doc: this.props.auth.uid,
      subcollections: [
        { collection: 'adminIssueMessages' }
      ],
      storeAs: 'adminIssueMessages'
    })  
    }
  }



  state = {
    sortFavorites: false,
    sortOnlineNotMenu: false,
    sortOpen: false,
    anyTags: false,
    sortTags: '',
    openList: '',
    updated: false,
    options: '',
    isLoaded: false
  }

  handleSelect = (selection) =>{
    this.setState({ sortTags: selection });
  }

  handleCheck = (e) => {
   this.setState({
    [e.target.id]: e.target.checked
   })
 } 

  onFavorite = (project) => {
  this.props.addFavorite(project);
    };

  componentDidUpdate(){
    var openList = hoursFunctions.compileHours(this.props.pending);
    var options = tagFunctions.compileTags(this.props.pending);
    if (JSON.stringify(this.state.openList)!==JSON.stringify(openList)){
      this.setState({openList:openList})
    }
    if (JSON.stringify(this.state.options)!==JSON.stringify(options)){
      this.setState({options:options})
    }
  }

  messagesExpand = (e) => {
    e.preventDefault();
    if(document.getElementById('messageExpand')!==null){
      if(document.getElementById('messageExpand').style.display==='none' || document.getElementById('messageExpand').style.display===''){
        document.getElementById('messageExpand').style.display = "block";  
      }
      else{
        document.getElementById('messageExpand').style.display = "none"; 
      }  
    } 
  }

  createExpand = (e) => {
    e.preventDefault();
    if(document.getElementById('createExpand').style.display==='none' || document.getElementById('createExpand').style.display===''){
      document.getElementById('createExpand').style.display = "block";  
    }
    else{
      document.getElementById('createExpand').style.display = "none"; 
    }  
  }

  editExpand = (e) => {
    e.preventDefault();
    if(document.getElementById('editExpand').style.display==='none' || document.getElementById('editExpand').style.display===''){
      document.getElementById('editExpand').style.display = "block";  
    }
    else{
      document.getElementById('editExpand').style.display = "none"; 
    }  
  }

  deleteExpand = (e) => {
    e.preventDefault();
    if(document.getElementById('deleteExpand').style.display==='none' || document.getElementById('deleteExpand').style.display===''){
      document.getElementById('deleteExpand').style.display = "block";  
    }
    else{
      document.getElementById('deleteExpand').style.display = "none"; 
    }  
  }

  reviewExpand = (e) => {
    e.preventDefault();
    if(document.getElementById('reviewExpand').style.display==='none' || document.getElementById('reviewExpand').style.display===''){
      document.getElementById('reviewExpand').style.display = "block";  
    }
    else{
      document.getElementById('reviewExpand').style.display = "none"; 
    }  
  }

  issuesExpand = (e) => {
    e.preventDefault();
    if(document.getElementById('issuesExpand').style.display==='none' || document.getElementById('issuesExpand').style.display===''){
      document.getElementById('issuesExpand').style.display = "block";  
    }
    else{
      document.getElementById('issuesExpand').style.display = "none"; 
    }  
  }

  reviewListExpand = (e) => {
    e.preventDefault();
    if(document.getElementById('reviewListExpand').style.display==='none' || document.getElementById('reviewListExpand').style.display===''){
      document.getElementById('reviewListExpand').style.display = "block";  
    }
    else{
      document.getElementById('reviewListExpand').style.display = "none"; 
    }  
  }

  render() {
    const { reviews, issues, auth, adminMessages, adminReviewMessages, adminIssueMessages, restaurants,
    pending, users, pendingCreate, pendingReviews, favorites, user } = this.props;
    if (!auth.uid) return <Redirect to='/signin' />


    var messagesLength = 0;
    if(adminMessages){  
      messagesLength = Object.keys(adminMessages).length;
      }


    var reviewMessagesLength = 0;
    if(adminReviewMessages){  
      reviewMessagesLength = Object.keys(adminReviewMessages).length;
      }

    var issueMessagesLength = 0;
    if(adminIssueMessages){  
      issueMessagesLength = Object.keys(adminIssueMessages).length;
      }


    var messages = adminMessages;
    var reviewMessages = adminReviewMessages;
    var issueMessages = adminIssueMessages;

    if(messages !== undefined && reviewMessages !== undefined && issueMessages !== undefined){
        var sortMessages = [];
        // array check is because deleted data was persisting in firestore
        if(messages && !Array.isArray(messages) && messages !== null){
          for(var message in messages){
            if(messages[message] !== undefined && messages[message] !== null && messages[message]['timestamp']){
              sortMessages.push([message, messages[message]['timestamp'].seconds, true])  
            }
          }  
        }
        if(reviewMessages && !Array.isArray(reviewMessages) && reviewMessages !== null){
         for(var message2 in reviewMessages){
            if(reviewMessages[message2] !== undefined && reviewMessages[message2] !== null && reviewMessages[message2]['timestamp']){
              sortMessages.push([message2, reviewMessages[message2]['timestamp'].seconds, false])
            }
          }   
        }
        if(issueMessages && !Array.isArray(issueMessages) && issueMessages !== null){
         for(var message3 in issueMessages){
            if(issueMessages[message3] !== undefined && issueMessages[message3] !== null && issueMessages[message3]['timestamp']){
              sortMessages.push([message3, issueMessages[message3]['timestamp'].seconds, null])
            }
          }   
        }
        
        sortMessages.sort(function(a, b) {
         return a[1] - b[1];
        });

//        sortMessages = sortMessages.reverse();
      }

    return (
      <div className="userDashboardContainer">
      { issues && user && favorites && auth && pending && pendingCreate && restaurants && users && pendingReviews &&
      <div className="centerMe" style={{"display": "flex", "flexFlow":"column", "justifyContent": "center"}}>
      
      <div className="wrapper">
      <h5  onClick = {this.messagesExpand} >{ messagesLength + reviewMessagesLength + issueMessagesLength} Messages</h5>
        { messages !== undefined && reviewMessages !== undefined && issueMessages !== undefined && restaurants && users &&
        <div className="row" id="messageExpand" > 
            { sortMessages &&
          Object.entries(sortMessages).map(thing=>{
          if(thing[1][2]){
            var timestamp = new Date(parseInt(messages[thing[1][0]].timestamp.seconds*1000, 10)).toLocaleString();
            return(
              <div key={'m'+ messages[thing[1][0]].messageId}>
              <p>{timestamp}</p>
              <p>
              <Link to={'/message/' + messages[thing[1][0]].senderId + '/' + messages[thing[1][0]].messageId +'/' + thing[1][0]} key={messages[thing[1][0]].project.id}>{ users.filter(user=>(user.id === messages[thing[1][0]].senderId))[0].firstName + ' ' + users.filter(user=>(user.id === messages[thing[1][0]].senderId))[0].lastName + ' ' + messages[thing[1][0]].project.name}</Link>
              </p> 
              </div>
            )
          }
          else if(thing[1][2] === null){
            var timestamp3 = new Date(parseInt(issueMessages[thing[1][0]].timestamp.seconds*1000, 10)).toLocaleString();
            return(
              <div key={'m'+ issueMessages[thing[1][0]].messageId}>
              <p>{timestamp3}</p>
              <p>
              <Link to={'/issueMessage/' + issueMessages[thing[1][0]].senderId + '/' + issueMessages[thing[1][0]].messageId +'/' + thing[1][0]} key={issueMessages[thing[1][0]].project[0]}>{ users.filter(user=>(user.id === issueMessages[thing[1][0]].senderId))[0].firstName + ' ' + users.filter(user=>(user.id === issueMessages[thing[1][0]].senderId))[0].lastName }</Link>
              </p> 
              </div>
            )
          }
          else{
            var timestamp2 = new Date(parseInt(reviewMessages[thing[1][0]].timestamp.seconds*1000, 10)).toLocaleString();
            return(
              <div key={'rm'+ reviewMessages[thing[1][0]].messageId}>
              <p>{timestamp2}</p>
              <p>
              <Link to={'/reviewMessage/' + reviewMessages[thing[1][0]].senderId + '/' + reviewMessages[thing[1][0]].messageId +'/' + thing[1][0] } key={reviewMessages[thing[1][0]].project.id}>{ users.filter(user=>(user.id === reviewMessages[thing[1][0]].senderId))[0].firstName + ' ' + users.filter(user=>(user.id === reviewMessages[thing[1][0]].senderId))[0].lastName + ' ' + restaurants.filter(restaurant=>restaurant.restaurantId === reviewMessages[thing[1][0]].project.restaurantId).map(project=>{return(project.name)}) }</Link>
              </p>
              </div>
            )
          }

          })

            }
        </div>
      }
      </div>


      <div className="wrapper">
      <h5  onClick = {this.createExpand} >{ pendingCreate.length } Restaurants Pending Creation</h5>
        { pendingCreate &&
        <div className="row" id="createExpand" > 
          <AdminRestaurantListCreate onFavorite = {this.onFavorite} projects={pendingCreate} favorites = {favorites} sortOptions = {this.state} restaurants={restaurants} users={users}/>
        </div>
        }
      </div>

      <div className="wrapper">
      <h5  onClick = {this.editExpand} >{ pending.length } Restaurants Pending Edit</h5>
        { pending &&
        <div className="row" id="editExpand" > 
          <AdminRestaurantList onFavorite = {this.onFavorite} projects={pending} favorites = {favorites} sortOptions = {this.state} restaurants={restaurants} users={users}/>
        </div>
        }
      </div>

      <div className="wrapper">
      <h5  onClick = {this.reviewExpand} >{ pendingReviews.length } Pending Reviews</h5>
        { pendingReviews &&
        <div className="row" id="reviewExpand" > 
          <AdminPendingReview projects={pendingReviews} users={users} restaurants={restaurants}/>
        </div>
        }
      </div>

      <div className="wrapper">
      <h5  onClick = {this.issuesExpand} >{ issues.length } Issues</h5>
        { issues &&
        <div className="row" id="issuesExpand" > 
          <AdminIssuesList/>
        </div>
        }
      </div>

      <div className="wrapper">
      <h5  onClick = {this.reviewListExpand} >{ reviews.length } Reviews</h5>
        { reviews &&
        <div className="row" id="reviewListExpand" > 
          <AdminReviewList/>
        </div>
        }
      </div>

      {<div className="wrapper">
      <h5  onClick = {this.deleteExpand} >{ restaurants.length } Restaurants</h5>
        { restaurants &&
        <div className="row" id="deleteExpand" > 
          <AdminRestaurantListDelete onFavorite = {this.onFavorite} projects={restaurants} favorites = {favorites} sortOptions = {this.state} users={users}/>
        </div>
        }
      </div>}

      </div>
    }
      </div>
    )
  }
}


const mapStateToProps = (state) => {
  const user = state.firestore.data.users
                && state.firestore.data.users[state.firebase.auth.uid]
  return {
    auth: state.firebase.auth,
    adminMessages: state.firestore.data.adminMessages,
    adminReviewMessages: state.firestore.data.adminReviewMessages,
    adminIssueMessages: state.firestore.data.adminIssueMessages,
    restaurants: state.firestore.ordered.restaurants,
    users: state.firestore.ordered.users,
    favorites: state.firestore.data.favorites,
    pending: state.firestore.ordered.pending,
    pendingCreate: state.firestore.ordered.pendingCreate,
    pendingReviews: state.firestore.ordered.pendingReviews,
    issues: state.firestore.ordered.issues,
    reviews: state.firestore.ordered.restaurantReviews2,
    user
  }
}

const mapDispatchToProps = dispatch => {
  return {
    addFavorite: (project) => dispatch(addFavorite(project))
  }
}

export default compose(
  connect(mapStateToProps,mapDispatchToProps),
  firestoreConnect(props =>{
    const userId = props.auth.uid
    if(!userId){
      return []
    }
    return[
    {
      collection: 'users',
      doc: props.auth.uid,
      subcollections: [
        { collection: 'adminMessages' }
      ],
      storeAs: 'adminMessages'
    },
    {
      collection: 'users',
      doc: props.auth.uid,
      subcollections: [
        { collection: 'adminReviewMessages' }
      ],
      storeAs: 'adminReviewMessages'
    },
    {
      collection: 'users',
      doc: props.auth.uid,
      subcollections: [
        { collection: 'adminIssueMessages' }
      ],
      storeAs: 'adminIssueMessages'
    }
  ]})
)(AdminDashboard)
